import styled, { css } from 'styled-components'

import { color, space, SpaceProps, typography } from '../../../../themes'

export const Container = styled.div<
  SpaceProps & {
    centered?: boolean
  }
>`
  ${space};
  ${typography('body1')};
  color: ${color('gray.02')};
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  ${({ centered }) =>
    centered &&
    css`
      justify-content: center;
      align-items: center;
    `}
}
`
